import Animated from 'react-native-reanimated';

const { Value, block, cond, clockRunning, startClock, stopClock, set, spring } = Animated;

/**
 * Performs a step of a spring animation for a given clock
 *
 * @param clock - A clock for a given animation
 * @param start - Starting position for the animation
 * @param destination - The destination value for the animation
 *
 * @returns The latest position of the animation
 */
export function runSpring(clock: Animated.Clock, start: number, destination: number) {
  /** If 1, the animation is finished, else 0 */
  const finished = new Value(0);
  /** Current position of the animating object */
  const position = new Value(0);
  /** The last time the animation step was executed */
  const time = new Value(0);
  /** Current velocity of the animating object */
  const velocity = new Value(0);
  const config = {
    ...Animated.SpringUtils.makeDefaultConfig(),
    overshootClamping: true,
  };

  return block([
    cond(
      // if animation has started
      clockRunning(clock),
      [
        // update the value we're animating to
        // (in case it changed since last call)
        set(config.toValue as Animated.Value<number>, destination),
      ],
      // else reset and start the animation
      [
        set(finished, 0),
        set(position, start),
        set(time, 0),
        set(velocity, 0),
        set(config.toValue as Animated.Value<number>, destination),
        startClock(clock), // start the animation clock
      ]
    ),
    spring(clock, { finished, position, time, velocity }, config), // apply the next step of the animation
    cond(finished, stopClock(clock)), // check if finished, then stop clock
    position,
  ]);
}
